module.exports = __webpack_public_path__ + "img/TTB.006f550d.png";